import { useState, useEffect, useContext, useCallback } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import {extractErrorMessage} from '../Services/RequestService';
import MessageService from '../Services/MessageService';

export const useMessages = (requirementId) => {
    const [messages, setMessages] = useState([]);
    const token = localStorage.getItem("token");
    const {setError} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await MessageService.allMessages(requirementId, token);
            setMessages(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const handleServiceWorkerMessage = useCallback(event => {
        if (event.data && event.data.type === 'NEW_MESSAGES_AVAILABLE') {
            loadAll();
        }
    }, []);

    const sendMessage = async (message) => {
        try {
            await MessageService.sendMessage(requirementId, message, token);
            await loadAll();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const markAsRead = () => MessageService.readMessage(requirementId, token) 

    useEffect(() => {
        loadAll()
    }, []);

    useEffect(() => {
        navigator.serviceWorker.addEventListener('message',handleServiceWorkerMessage);
        return () => {
            navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
        };
    }, []);

    return [messages, sendMessage, markAsRead];
}


// WEBPACK FOOTER //
// ./src/Hooks/useMessages.js